import type { Modifier } from "@dnd-kit/core";

/**
 * Limit movement to the x-axis if the dragged node contains the data 'target: span-control'
 */
export const restrictDragDirectionOfSpanControls: Modifier = ({
  active,
  containerNodeRect,
  draggingNodeRect,
  transform,
}) => {
  const isSpanControl = active?.data.current?.target === "span-control";

  let originalYDiff = -4;
  if (draggingNodeRect && containerNodeRect) {
    // if the window scrolls or is resized, we need to make the y axis relative to the container
    originalYDiff = containerNodeRect?.top - draggingNodeRect?.top;
  }

  return isSpanControl
    ? {
        ...transform,
        y: originalYDiff,
      }
    : transform;
};
